import { User } from 'platform-unit2-api/users';
import { UserState } from 'supplier/modules/users/user.types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<UserState, {}> = {
  currentUser(state: UserState): User | undefined {
    return state.user;
  },
};
